module.exports = __webpack_public_path__ + "media/images/no_animation-06ef0225.png";